import React from 'react'
import styled from 'styled-components'
import {TrendingUp, TrendingDown} from 'lucide-react'

interface MetricCardProps {
  title: string
  value: string
  icon?: React.ReactNode
  change?: {
    value: string
    type: 'increase' | 'decrease' | 'neutral'
  }
  className?: string
}

const CardContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const CardHeader = styled.div`
  display: flex;
  justify-content: between;
  align-items: center;
`

const CardTitle = styled.h3`
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  flex: 1;
`

const CardIcon = styled.div`
  color: #9ca3af;
  flex-shrink: 0;
`

const CardValue = styled.div`
  color: #111827;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
`

const CardChange = styled.div<{$type: 'increase' | 'decrease' | 'neutral'}>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => {
    switch (props.$type) {
      case 'increase':
        return '#059669'
      case 'decrease':
        return '#dc2626'
      default:
        return '#6b7280'
    }
  }};
`

export const MetricCard: React.FC<MetricCardProps> = ({title, value, icon, change, className}) => {
  const renderChangeIcon = () => {
    if (!change) return null

    switch (change.type) {
      case 'increase':
        return <TrendingUp size={16} />
      case 'decrease':
        return <TrendingDown size={16} />
      default:
        return null
    }
  }

  return (
    <CardContainer className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {icon && <CardIcon>{icon}</CardIcon>}
      </CardHeader>
      <CardValue>{value}</CardValue>
      {change && (
        <CardChange $type={change.type}>
          {renderChangeIcon()}
          {change.value}
        </CardChange>
      )}
    </CardContainer>
  )
}

export default MetricCard
